import { render } from "./ExamEventReport.vue?vue&type=template&id=b3165702&scoped=true"
import script from "./ExamEventReport.vue?vue&type=script&lang=js"
export * from "./ExamEventReport.vue?vue&type=script&lang=js"

import "./ExamEventReport.vue?vue&type=style&index=0&id=b3165702&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3165702"]])

export default __exports__